import Image from "next/image";
import React from "react";
import Lottie from "lottie-react";
import data from "../../public/contact/text_HI.json";
import { useRouter } from "next/router";

function Hero() {
  const { locale } = useRouter();
  return (
    <div
      className={`h-[186px] sm:h-[250px] mds:h-[300px] w-full relative ${
        locale == "ar" ? "pr-20 md:pr-32 " : ""
      }`}
    >
      <Lottie animationData={data} loop={true} className="h-full" />
    </div>
  );
}

export default Hero;
